import { ArrowsClockwise, CheckCircle, Lightbulb, Target } from "@phosphor-icons/react";

// VAGUE 46 — note et retours après un jeu de rôle.
export default function TrainingEvaluation({ evaluation, passScore, onRetry }) {
  const ev = evaluation;
  return (
    <div className="space-y-3" data-testid="training-evaluation">
      <div className={`rounded-sm p-4 text-center border ${ev.passed ? "bg-emerald-50 border-emerald-200" : "bg-amber-50 border-amber-200"}`}>
        <div className="font-display text-4xl font-semibold" data-testid="training-score">{ev.score}/10</div>
        <div className="text-sm font-semibold mt-1" data-testid="training-passed">
          {ev.passed ? "Module validé, bravo !" : `Encore un essai : il faut ${passScore}/10 pour valider.`}
        </div>
        <div className="text-[10px] uppercase tracking-wider text-muted-foreground mt-1" data-testid="training-eval-source">
          {ev.source === "ai" ? "Évaluation IA" : "Évaluation standard"}
        </div>
      </div>
      <div>
        <div className="text-[10px] uppercase tracking-widest font-bold text-emerald-700 mb-1 flex items-center gap-1"><CheckCircle size={12}/> Points forts</div>
        <ul className="space-y-1">{ev.strengths.map((s, i) => <li key={i} className="text-sm" data-testid={`training-strength-${i}`}>• {s}</li>)}</ul>
      </div>
      <div>
        <div className="text-[10px] uppercase tracking-widest font-bold text-amber-700 mb-1 flex items-center gap-1"><Target size={12}/> À améliorer</div>
        <ul className="space-y-1">{ev.improvements.map((s, i) => <li key={i} className="text-sm" data-testid={`training-improvement-${i}`}>• {s}</li>)}</ul>
      </div>
      <div className="border border-primary/30 bg-primary/5 rounded-sm p-2.5 text-sm" data-testid="training-better-phrase">
        <div className="text-[10px] uppercase tracking-widest font-bold text-primary mb-0.5 flex items-center gap-1"><Lightbulb size={12}/> Formulation conseillée</div>
        « {ev.better_phrase} »
      </div>
      <button type="button" onClick={onRetry} className="w-full border border-border rounded-sm py-2 text-sm font-semibold flex items-center justify-center gap-2 hover:border-primary"
        data-testid="training-retry">
        <ArrowsClockwise size={14}/> Revoir la leçon et recommencer
      </button>
    </div>
  );
}
